import React from 'react';
import { Box, Typography, Button, Stack } from '@curves/ui-base';
import clsx from 'clsx';


/**
 * ScoreSummaryCard - InBody 總分與體型分類摘要卡片組件
 *
 * @component
 * @param {Object} props - 組件屬性
 * @param {string} [props.className] - 額外的 CSS 類別名稱
 * @param {number} props.totalInBodyScore - InBody 總分數值
 * @param {string} props.bodyTypeLabel - 體型分類標籤文字（例如：'強健型'、'標準型' 等）
 * @param {string} [props.scoreColorTheme='primary'] - 總分數值的顏色主題，可用值：'primary'、'secondary'、'success'、'error'、'warning'、'info'
 * @param {string} [props.gradeColorTheme='success'] - 體型分類標籤的顏色主題，可用值：'primary'、'secondary'、'success'、'error'、'warning'、'info'
 * @param {boolean} [props.showBodyTypeAnalysis=false] - 是否顯示體型分類分析狀態
 * @param {Function} [props.onToggleBodyTypeAnalysis] - 點擊「查看分析」按鈕時的回調函數
 * @returns {JSX.Element} ScoreSummaryCard 組件
 */
const ScoreSummaryCard = ({
    className,
    totalInBodyScore,
    bodyTypeLabel,
    scoreColorTheme = 'primary',
    gradeColorTheme = 'success',
    showBodyTypeAnalysis = false,
    onToggleBodyTypeAnalysis,
}) => {
    return (
        <Stack className={clsx('score-summary-card', className)} justifyContent="space-between" alignItems="center" spacing={2}>
            <Box className="left-group">
                <Typography className="label">InBody 總分</Typography>
                <Typography className={clsx('score', scoreColorTheme)}>{totalInBodyScore}</Typography>
            </Box>
            <Box className="right-group">
                <Typography className="label">體型分類</Typography>
                <Typography className={clsx('grade', gradeColorTheme)}>{bodyTypeLabel}</Typography>
                {onToggleBodyTypeAnalysis && (
                    <Button className="link" onClick={onToggleBodyTypeAnalysis}>
                        {showBodyTypeAnalysis ? '隱藏分析' : '查看分析'}
                    </Button>
                )}
            </Box>
        </Stack>
    );
};

export default ScoreSummaryCard;
